import { invoke } from '@shared/easyfy.decorators';
import { Filter } from '@clientWebModules/filter';
import { FilterFor } from '@clientShared/filter.types';
import ToggleCss from '@shared/easyfy.togglecss';
import ScrollTo from '@shared/easyfy.scrollto';

@invoke
export default class ArticleAuthorDetail {
  static Instance: ArticleAuthorDetail;

  constructor() {
    void new ToggleCss('togglecss');
    void new ScrollTo('smooth', true);
  }

  onInit() {
    void new Filter(
      FilterFor.Articles,
      '[data-container="filter"]',
      '[data-container="paging"]',
      '[data-container="articles"]',
      '[data-container="sorter"]',
      '[data-container="selected-filters"]',
      true
    );
  }
}
